export function Article({ kicker, title, body }: { kicker: string; title: string; body: string }) {
  const blocks = body.split(/\n{2,}/).map((block) => block.trim()).filter(Boolean);
  return (
    <article className="preview-sheet">
      <p className="kicker">{kicker}</p>
      <h2>{title || "Untitled"}</h2>
      {blocks.length === 0 ? <p className="muted">Nothing written yet.</p> : blocks.map((block, index) => <p key={`${index}-${block.slice(0, 24)}`}>{block}</p>)}
    </article>
  );
}
